import { Navigate, Route, Routes } from 'react-router-dom'
import HomePage from './pages/HomePage'
import MediaKitPage from './pages/MediaKitPage'
import Layout from './components/Layout'
import PaymentDemoPage from './pages/PaymentDemoPage'
import DocsPage from './pages/DocsPage'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/payments" element={<PaymentDemoPage />} />
        <Route path="/docs" element={<DocsPage />} />
        <Route path="/media" element={<MediaKitPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
